module.exports = __webpack_public_path__ + "710debc12717a7bdbc8af65fea3538a0.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-62.cur
// module id = 469
// module chunks = 0